export const getBitcoinBalance = async (address) => {
	const response = await fetch(`https://blockchain.info/q/addressbalance/${address}`);
	const satoshis = await response.json();
	return satoshis / 100000000; // Convert satoshis to BTC
};